import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";

export default function NavBar({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="border-b-2 border-black bg-white sticky top-0 z-50 px-6 md:px-10 py-3 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2">
        <div className="w-9 h-9 bg-[#FFD600] border-2 border-black flex items-center justify-center font-display text-lg">T</div>
        <span className="font-display text-xl">TAXI/X</span>
      </Link>
      <div className="flex items-center gap-4">
        {children}
        {user && (
          <>
            <NotificationBell />
            <span className="hidden sm:inline-block brut-badge" data-testid="nav-user-name">{user.name}</span>
            {user.role === "driver" && (
              <>
                <Link data-testid="nav-agenda-link" to="/driver/agenda" className="font-mono-eyebrow hidden sm:block hover:underline">Agenda</Link>
                <Link data-testid="nav-stats-link" to="/driver/stats" className="font-mono-eyebrow hidden sm:block hover:underline">Stats</Link>
              </>
            )}
            <Link data-testid="nav-history-link" to="/history" className="font-mono-eyebrow hidden sm:block hover:underline">Historique</Link>
            <button data-testid="nav-logout-btn" onClick={async () => { await logout(); navigate("/"); }} className="brut-btn brut-btn-secondary">Déconnexion</button>
          </>
        )}
      </div>
    </header>
  );
}
